<section class="w-185 flex flex-col flex-wrap justify-start shadow-nx rounded-gt-md-7 p-12 box-content">
    <span class="gt-greytip-header-logo mb-20 block m-auto" *ngIf="!disableGreytHrLogo"></span>
    <div class="gt-maintainance-notice"></div>
    <div class="mt-4">
        <div class="flex flex-col p-5 rounded-gt-md-4 w-185 h-auto bg-std-info">
            <div class="opacity-90 text-7gpx text-text-default font-body">
                Our site is getting a little tune up.
            </div>
        </div>
    </div>
    <p class="ml-2 mt-4 font-normal text-center text-6gpx text-notice">
        {{notes?.description}}
    </p>
    <div class="ml-2 mt-4 time-in">
        <p class="font-body font-normal text-6gpx text-notice mb-1">We'll see you soon by</p>
        <h5 class="font-semibold text-9gpx font-body-semibold">{{notes?.end_time | gtCalendarTime}}</h5>
    </div>
</section>
